import useApi from "../../../composables/useApi";
import { AvailableDates, AvailableDatesResult } from "../models/AvailableDates";

const { get } = useApi();
const useAvailableDates = () => {
    const getDates = (route: string) => {
        return get<AvailableDatesResult>(`/dates/${route}`, {}).then((resp) => {
            return new AvailableDates(resp.data);
        });
    };

    return {
        getDates,
    };
};

export default useAvailableDates;
